import { AjaxResponse } from '@src/common/ajax/types';
import { LaFilters } from '../types';
import { laFetchNodeTypes } from './laFetchNodeTypes';

export async function laFetchFilters(): Promise<AjaxResponse<LaFilters>> {
  const {
    payload: { nodeTypeSelectOptions, nodeTypes },
    ...rest
  } = await laFetchNodeTypes();
  const idTypeSelectOptions = JSON.parse(JSON.stringify(nodeTypeSelectOptions));

  return {
    payload: {
      nodeTypes,
      nodeTypeSelectOptions,
      idTypeSelectOptions,
    },
    ...rest,
  };
}
